var map = {
	"./ai/Sidebar.vue": 20978,
	"./ai/Tab.vue": 10560,
	"./custom-widget-ai/ChatTool.vue": 83216,
	"./james-translations/SidebarInfo.vue": 39466,
	"./spreadsheet/Toggle.vue": 46657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43892;